import { Box, Container, Fade, CircularProgress } from "@mui/material";
import { Navigate, useNavigate, Route, Routes } from "react-router";
import AppBar from "../components/AppBar";
import ViewCompanyInfo from "./ViewCompanyInfo";
import CompanyStatsPage from "./CompanyStatsPage";
import CompanyLocationPage from "./CompanyLocationPage"
import CompanyStudentStats from "./CompanyStudentStats";
import ManageCompanyStaffPage from "./ManageCompanyStaffPage";
import { ManageModal, ManageModalProvider, SlideIn } from "ui";
import MainMenu from "../components/MainMenu";
import ShiftContainer from "../../components/ShiftContainer";
import { useState } from "react";
const CompanyManagementRoutes = () => {
    const navigate = useNavigate();
    // const params = useParams();
    // if (params.lid) { 

    // }
    return (
        <Routes>
            <Route index element={<ViewCompanyInfo onBack={() => navigate(-1)} />} />
            <Route path="location/:lid" element={<CompanyLocationPage onBack={() => navigate(-1)} />} />
            <Route path="location/:lid/staff" element={<ManageCompanyStaffPage onBack={() => navigate(-1)} />} />
            <Route path="students" element={<CompanyStudentStats onBack={() => navigate(-1)} />} />
            <Route path="stats" element={<CompanyStatsPage onBack={() => navigate(-1)} />} />
            <Route path="*" element={<Navigate to="." replace />} />
        </Routes>
    )
}

export const CompanyIndexPage = () => {
    const loading = false;
    const [containerNode, setContainerNode] = useState<HTMLDivElement | null>(null)

    return (
        <Fade in={true}>
            <Box component="div">
                <ManageModal />
                <div>
                    <SlideIn />
                    <AppBar />
                    <MainMenu />
                </div>
                <ShiftContainer containerRef={containerNode}>
                    <Container ref={setContainerNode} maxWidth="xl">
                        <Box component="div" sx={{ paddingTop: "40px", paddingBottom: "32px" }}>
                            {loading ? (
                                <div
                                    style={{
                                        width: "100%",
                                        height: "50vh",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                    }}
                                >
                                    <CircularProgress />
                                </div>
                            ) : (
                                <CompanyManagementRoutes />
                            )}
                        </Box>
                    </Container>
                </ShiftContainer>
            </Box>
        </Fade>
    )
}